(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const titleSelector = [
    '.hanfi-home__heading-row',
    '.hanfi-shoppable-videos__header',
    '.section-header',
    '.section__header',
    '.collection-list__header',
    '.product-recommendations__header',
  ].join(',');

  const interactiveCardSelector = [
    '.hanfi-home__occasion-card',
    '.hanfi-home__product-card',
    '.hanfi-home__weave-feature',
    '.hanfi-home__weave-tile',
    '.hanfi-home__finder-option',
    '.hanfi-home__ugc-card',
    '.hanfi-shoppable-card',
    '.product-card',
    'product-card',
    '.collection-card',
    '.resource-card',
  ].join(',');

  const revealCardSelector = [
    interactiveCardSelector,
    '.hanfi-home__trust',
    '.hanfi-home__testimonial',
    '.hanfi-story-upgrade__copy',
    '.hanfi-story-upgrade__media-wrap',
  ].join(',');

  const revealSelector = `${titleSelector},${revealCardSelector}`;

  const canReveal = (element) => {
    if (!(element instanceof HTMLElement) || element.dataset.hanfiRevealPrepared === 'true') return false;
    if (element.closest('[hidden], template, dialog:not([open])')) return false;
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.top > window.innerHeight * 0.88;
  };

  const mountCardFeedback = () => {
    document.querySelectorAll(`#MainContent ${interactiveCardSelector}`).forEach((element) => {
      if (element instanceof HTMLElement) element.setAttribute('data-hanfi-motion-card', '');
    });
  };

  const mountSectionReveals = () => {
    if (reduceMotion.matches || !('IntersectionObserver' in window)) return;

    const sections = Array.from(document.querySelectorAll('#MainContent > .shopify-section'));
    const candidates = [];

    sections.forEach((section) => {
      if (!(section instanceof HTMLElement)) return;

      const nested = Array.from(section.querySelectorAll(revealSelector)).filter(canReveal);
      const targets = [];
      nested.forEach((element) => {
        if (targets.length >= 24 || targets.some((parent) => parent.contains(element))) return;
        targets.push(element);
      });

      if (!targets.length && canReveal(section)) targets.push(section);

      let cardIndex = 0;
      targets.forEach((element) => {
        const isTitle = element.matches(titleSelector);
        const isCard = element.matches(revealCardSelector);
        const delay = isCard ? Math.min(cardIndex++ % 4, 3) * 45 : 0;
        element.dataset.hanfiRevealPrepared = 'true';
        element.dataset.hanfiRevealKind = isTitle ? 'title' : isCard ? 'card' : 'section';
        element.setAttribute('data-hanfi-reveal-item', '');
        element.style.setProperty('--hanfi-reveal-delay', `${delay}ms`);
        candidates.push(element);
      });
    });

    if (!candidates.length) return;
    document.documentElement.classList.add('hanfi-motion-ready');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.08,
    });

    candidates.forEach((element) => observer.observe(element));
  };

  const pulseCartDestination = () => {
    if (reduceMotion.matches) return;
    const destinations = Array.from(document.querySelectorAll(
      '.hanfi-header-pro__icon-button[aria-label="Cart"], [aria-controls="cart-drawer"], .hanfi-mobile-bottom-nav__item[aria-label*="Bag" i]'
    ));
    const destination = destinations.find((element) => {
      const rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && getComputedStyle(element).visibility !== 'hidden';
    });
    if (!(destination instanceof HTMLElement)) return;

    destination.animate(
      [
        { transform: 'translate3d(0, 0, 0) scale(1)' },
        { transform: 'translate3d(0, -1px, 0) scale(1.12)', offset: 0.42 },
        { transform: 'translate3d(0, 0, 0) scale(1)' },
      ],
      { duration: 280, easing: 'cubic-bezier(.23, 1, .32, 1)' }
    );
  };

  document.addEventListener('hanfi:fly-to-cart:complete', pulseCartDestination);

  const mountMotion = () => {
    mountCardFeedback();
    mountSectionReveals();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountMotion, { once: true });
  } else {
    mountMotion();
  }

  document.addEventListener('shopify:section:load', mountMotion);
})();
